module.exports = "<div class=\"font-size-11 text-muted ellipsis\" style=margin-top:-2px>{{data[0]}}</div> <div>{{data[1]}}</div> ";